import React from 'react'

type BlankLayoutProps = {
  children: React.ReactElement,
}

const BlankLayout = ({ children }: BlankLayoutProps): React.ReactElement => <div data-testid="blankLayout">{children}</div>

export default BlankLayout
